module.exports = __webpack_public_path__ + "static/img/pic_ppt_big.18f50495.png";